import { profileApi, ContactType, ContactResponse } from '@commerce-profile-webcomponents/sdk';
import { defaultApiErrorHandler } from './helper';

export const getShippingAddressListUtil = async (
  contactType: ContactType,
  ownerId: string,
  accountNumber: string,
  apiErrorHandler = defaultApiErrorHandler,
) => {
  const AddressResponse = await apiErrorHandler(() =>
    profileApi.getShippingAddressList({ contactType, ownerId, accountNumber }),
  );
  return AddressResponse;
};

export const getDownlineAddressListUtil = async (
  contactType: ContactType,
  ownerId: string,
  accountNumber: string,
  apiErrorHandler = defaultApiErrorHandler,
): Promise<ContactResponse> => {
  const AddressResponse = await apiErrorHandler(() =>
    profileApi.getDownlineAddressList({ contactType, ownerId, accountNumber }),
  );
  return AddressResponse;
};

export const getAddressByContactId = async (contactId: string, apiErrorHandler = defaultApiErrorHandler) => {
  const AddressResponse = await apiErrorHandler(() => profileApi.getAddressByContactId(contactId));
  return AddressResponse;
};
